import { render, staticRenderFns } from "./search.vue?vue&type=template&id=e4c7e318&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"
import style0 from "./search.vue?vue&type=style&index=0&id=e4c7e318&prod&lang=scss&"
import style1 from "./search.vue?vue&type=style&index=1&id=e4c7e318&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzIconSearch: require('/opt/airport.kg/node_modules/razlet-ui/src/icons/icon-search/index.vue').default,BaseAutocomplete: require('/opt/airport.kg/src/components/base/autocomplete.vue').default})
